import {
  ISearch,
  ISearchProfile,
  ISearchProvider,
  HorizAlignment,
  SearchProviderFieldType,
  ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import * as _ from "lodash";
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {IUsrContext} from "../PA.Core/PA.Core.IF.User";

var TPMEventSearch: ISearch = {
  searchName: "Find TPM Event",
  renderOptions: { ui5ResourceId: "TPMEventSearch"},
  searchProfileIdDefault: "default",
  searchProfiles: []
}

var vUI_TPM_Event_Search_Fields: {[id:string]: ISearchProviderField } = {

  WB_TEVT_ID:           {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Event Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
  WB_PLAN_ID:           {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Plan Id', columnResourceName: 'colwbPlanId', alignment: HorizAlignment.Center}, domainOptions: {}},
  WB_CUST_ID_PLANNING:  {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Cust Id Planning', columnResourceName: 'colwbCustIdPlanning', alignment: HorizAlignment.Center}, domainOptions: {}},
  WB_SALESORG_ID:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Sales Org Id', columnResourceName: 'colwbSalesOrgId', alignment: HorizAlignment.Center}, domainOptions: {}},
  EVENT_ID:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Event Id', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
  EVENT_NAME:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Event Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
  TYPE_NAME:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Type', columnResourceName: 'colTypeName', alignment: HorizAlignment.Left}, domainOptions: { search: TPMEventSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
  PLAN_NAME:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Plan', columnResourceName: 'colTypeName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
  PLANNINGCUSTOMER:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Planning Customer', columnResourceName: 'colPlanningCustomer', alignment: HorizAlignment.Left}, domainOptions: { search: TPMEventSearch, profileId:"default", bUseSearchProvidersDistinctValues: true,maxLength: 256}},
  SUBPLANNINGCUSTOMER: {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Sub Planning Customer', columnResourceName: 'colSubPlanningCustomer', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
  INSTORE_START_DT:    {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'In Store Start Date', columnResourceName: 'colInStoreStart', alignment: HorizAlignment.Center}, domainOptions: {}},
  INSTORE_END_DT:      {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'In Store End Date', columnResourceName: 'colInStoreEnd', alignment: HorizAlignment.Center}, domainOptions: {}},
  SHIPMENT_START_DT:   {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Shipment Start Date', columnResourceName: 'colShipmentStart', alignment: HorizAlignment.Center}, domainOptions: {}},
  SHIPMENT_END_DT:     {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Shipment End Date', columnResourceName: 'colShipmentEnd', alignment: HorizAlignment.Center}, domainOptions: {}},
  CURRENT_STATUS_NAME: {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Status', columnResourceName: 'colStatus', alignment: HorizAlignment.Left}, domainOptions: {search: TPMEventSearch, profileId: "default", bUseSearchProvidersDistinctValues: true,  maxLength: 256}},
  NEXT_STATUS_NAME:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Next Status', columnResourceName: 'colNextStatus', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
  NEXT_APPROVER:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Next Approver', columnResourceName: 'colNextApprover', alignment: HorizAlignment.Left}, domainOptions: {search: TPMEventSearch, profileId: "default", bUseSearchProvidersDistinctValues: true,  maxLength: 256}},
  CREATED_BY:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Created By', columnResourceName: 'colCreatedBy', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
  PLANNING_LEVEL_ID:    {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Planning Level ID',       columnResourceName: 'colLevelID', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
  PLANNING_LEVEL_NAME:  {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Planning Level',          columnResourceName: 'colLevelName', alignment: HorizAlignment.Left}, domainOptions: { search: TPMEventSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
  PLAN_PERIOD_NAME:            {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Plan Period',             columnResourceName: 'colPlanPeriodName', alignment: HorizAlignment.Left}, domainOptions: {search: TPMEventSearch, profileId: "default", bUseSearchProvidersDistinctValues: true,  maxLength: 256}},
  CREATED_DTTS: {
      type: SearchProviderFieldType.sapdate,
      renderOptions: {
        columnName: 'Created Date',
        columnResourceName: 'colCreateDt',
        alignment: HorizAlignment.Center,
        dateFormat: "MM-dd-yy"
      },
      domainOptions: {}
    },
    MODIFIED_DTTS: {
      type: SearchProviderFieldType.sapdate,
      renderOptions: {
        columnName: 'Modified Date',
        columnResourceName: 'colModifiedDt',
        alignment: HorizAlignment.Center,
        dateFormat: "MM-dd-yy"
      },
      domainOptions: {}
    }}



var vUI_CustomerControl_Event_Zero_Rate: {[id:string]: ISearchProviderField } = {

  WB_TEVTS_ID:           {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Event Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
  EVENT_SPEND_ID:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Event Spend Id', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
  EVENT_SPEND_NAME:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Event Spend Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
  ACTUAL_SPEND:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Actual Spend', columnResourceName: 'colTypeName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
  PLANNED_SPEND:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Planned Spend', columnResourceName: 'colTypeName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
  PRODUCT_GROUP_ID:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Product Group Id', columnResourceName: 'colPlanningCustomer', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
  INSTORE_START_DT:    {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'In Store Start Date', columnResourceName: 'colInStoreStart', alignment: HorizAlignment.Center}, domainOptions: {}},
  INSTORE_END_DT:      {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'In Store End Date', columnResourceName: 'colInStoreEnd', alignment: HorizAlignment.Center}, domainOptions: {}},
}


var vUI_CustomerControl_Event_No_PPG: {[id:string]: ISearchProviderField } = {
  WB_TEVTS_ID:           {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Event Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
  EVENT_ID:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Event Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {maxLength: 50}},
  EVENT_NAME:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Event Name', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
  EVENT_SPEND_ID:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Event Spend Id', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
  EVENT_SPEND_NAME:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Event Spend Name', columnResourceName: 'colTypeName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
  RATE_AMT:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Rate Amount', columnResourceName: 'colTypeName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
  INSTORE_START_DT:    {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'In Store Start Date', columnResourceName: 'colInStoreStart', alignment: HorizAlignment.Center}, domainOptions: {}},
  INSTORE_END_DT:      {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'In Store End Date', columnResourceName: 'colInStoreEnd', alignment: HorizAlignment.Center}, domainOptions: {}},
}

var vUI_CustomerControl_Event_No_Tactic: {[id:string]: ISearchProviderField } = {
  WB_TEVTS_ID:           {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Event Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
  EVENT_ID:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Event Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {maxLength: 50}},
  EVENT_NAME:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Event Name', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
  INSTORE_START_DT:    {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'In Store Start Date', columnResourceName: 'colInStoreStart', alignment: HorizAlignment.Center}, domainOptions: {}},
  INSTORE_END_DT:      {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'In Store End Date', columnResourceName: 'colInStoreEnd', alignment: HorizAlignment.Center}, domainOptions: {}},
  SHIPMENT_START_DT:    {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Shipment Start Date', columnResourceName: 'colInStoreStart', alignment: HorizAlignment.Center}, domainOptions: {}},
  SHIPMENT_END_DT:      {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Shipment End Date', columnResourceName: 'colInStoreEnd', alignment: HorizAlignment.Center}, domainOptions: {}},
  EVENT_SPEND_ID:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Event Spend Id', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
}

var vUI_Tactics_Refresh_Fields: {[id:string]: ISearchProviderField } = {
  WB_TEVTS_ID:           {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Event Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
  WB_TEVT_ID:           {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Event Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
  WB_PLAN_ID:           {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Plan Id', columnResourceName: 'colwbPlanId', alignment: HorizAlignment.Center}, domainOptions: {}},
  WB_CUST_ID_PLANNING:  {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Cust Id Planning', columnResourceName: 'colwbCustIdPlanning', alignment: HorizAlignment.Center}, domainOptions: {}},
  WB_SALESORG_ID:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Sales Org Id', columnResourceName: 'colwbSalesOrgId', alignment: HorizAlignment.Center}, domainOptions: {}},
  PLAN_ID:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Plan ID', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {maxLength: 50}},
  PLAN_NAME:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Plan Name', columnResourceName: 'colTypeName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
  EVENT_ID:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Event ID', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {maxLength: 50}},
  EVENT_NAME:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Event Name', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
  TACTIC_ID:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Tactic ID', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {maxLength: 50}},
  TACTIC_NAME:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Tactic Name', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
  TACTIC_SHIPMENT_START_DT:    {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Tactic Start Date', columnResourceName: 'colInStoreStart', alignment: HorizAlignment.Center}, domainOptions: {}},
  TACTIC_SHIPMENT_END_DT:      {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Tactic End Date', columnResourceName: 'colInStoreEnd', alignment: HorizAlignment.Center}, domainOptions: {}},
  STATUS_NAME:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Tactic Status', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
  ISSUE_TYPE:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Issue Type', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
  PRODUCT_ID:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Product ID', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {maxLength: 50}},
  PRODUCT_NAME:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Product Name', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {maxLength: 50}},

}

var vUI_Tactics_Refresh_Status: {[id:string]: ISearchProviderField } = {
  WB_TEVT_ID:           {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Event Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
  WB_PLAN_ID:           {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Plan Id', columnResourceName: 'colwbPlanId', alignment: HorizAlignment.Center}, domainOptions: {}},
  WB_CUST_ID_PLANNING:  {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Cust Id Planning', columnResourceName: 'colwbCustIdPlanning', alignment: HorizAlignment.Center}, domainOptions: {}},
  WB_SALESORG_ID:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Sales Org Id', columnResourceName: 'colwbSalesOrgId', alignment: HorizAlignment.Center}, domainOptions: {}},
  EVENT_ID:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Event ID', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {maxLength: 50}},
  EVENT_NAME:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Event Name', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
  EVENT_STATUS:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Event Status', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
  EVENT_SPEND_ID:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Tactic ID', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {maxLength: 50}},
  EVENT_SPEND_NAME:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Tactic Name', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
  TACTIC_STATUS:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Tactic Status', columnResourceName: 'colId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50, domainIds: 'Tactic_Status', useIdAsKey: true}},
  TACTIC_ID:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Tactic ID', columnResourceName: 'colTacticId', alignment: HorizAlignment.Center}, domainOptions: {maxLength: 50}},
  EVENT_SPEND_TYPE:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Tactic Type', columnResourceName: 'colTacticTypeName', alignment: HorizAlignment.Left}, domainOptions: { search: TPMEventSearch, profileId: "EventSearchProfileByTacticRefreshStatus", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
  PLANNINGCUSTOMER:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Planning Customer', columnResourceName: 'colPlanningCustomer', alignment: HorizAlignment.Left}, domainOptions: { search: TPMEventSearch, profileId:"default", bUseSearchProvidersDistinctValues: true,maxLength: 256}},
  PLANNING_LEVEL_ID:    {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Planning Level ID',       columnResourceName: 'colLevelID', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
  PLANNING_LEVEL_NAME:  {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Planning Level',          columnResourceName: 'colLevelName', alignment: HorizAlignment.Left}, domainOptions: { search: TPMEventSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
  PLAN_PERIOD_NAME:            {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Plan Period',             columnResourceName: 'colPlanPeriodName', alignment: HorizAlignment.Left}, domainOptions: {search: TPMEventSearch, profileId: "default", bUseSearchProvidersDistinctValues: true,  maxLength: 256}},

}


var EventSearchProviderBasic: ISearchProvider = {

  keyFields: {id:        'WB_TEVT_ID',
    id_ui:     'EVENT_ID',
    name:      'EVENT_NAME',
    source_id: 'SOURCE_ID'
  },

  searchProviderFields: vUI_TPM_Event_Search_Fields,

  search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
    let results: any[]


    let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
        'vUI_TPM_Event_Search',
        this.searchProviderFields,
        [])

    async function searchPlans(findRequest: any) {
      try {
        let usrContext: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
        if (!usrContext.hasRoleId('VIEW_ALL')) {
          await SearchUtils.addUserGroupPlansFilter(findRequest, 'WB_PLAN_ID')
          SearchUtils.addUsrContextCustomerFilter(findRequest, 'WB_CUST_ID_PLANNING')
        }
        SearchUtils.addUsrContextSalesOrgFilter(findRequest, 'WB_SALESORG_ID')

        results = await PASearch.findByRequest(findRequest)

        return results
      } catch (err) {
        console.log("failed to retrieve events: " + err)
      }
    }

    return searchPlans(findRequest)
  },

  // Filter with drop down in the TPM Event Search
  distinctValues(fieldName: string): Promise<string[] | number[]> {
    return new Promise<string[] | number[]>((resolve, error) => {
      let findRequest = SearchUtils.makeSearchRequest({},
          'vUI_TPM_Event_Search',
          this.searchProviderFields,
          [fieldName])

      let usrContext: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
      SearchUtils.addUsrContextSalesOrgFilter(findRequest, 'WB_SALESORG_ID')

      if (usrContext.hasRoleId('VIEW_ALL')) {
        PASearch.findByRequest(findRequest)
            .then((res: any[]) => {
              resolve(_.map(res, (aRow) => { return aRow[fieldName] }))
            })
            .catch((err)=> {
              error(err)
            })
        return
      }

      SearchUtils.addUsrContextCustomerFilter(findRequest, 'WB_CUST_ID_PLANNING')

      SearchUtils.addUserGroupPlansFilter(findRequest, 'WB_PLAN_ID')
          .then((ignore) => {
            return PASearch.findByRequest(findRequest)
          })
          .then((res: any[]) => {
            resolve(_.map(res, (aRow) => { return aRow[fieldName] }))
          })
          .catch((err)=> {
            error(err)
          })
    })
  }

}

/* AB#1709969: disabled — underlying views (vUI_CustomerControl_Event_Zero_Rate / _No_PPG / _No_Tactic) are not
   present in this repo, so no access filter (Plan Management / User Group / Customer) can be verified for them.
const EventSearchProviderZeroRate: ISearchProvider =
    {
      keyFields: {id:        'WB_TEVT_ID',
        id_ui:     'EVENT_ID',
        name:      'EVENT_NAME',
      },


      searchProviderFields: vUI_CustomerControl_Event_Zero_Rate,

      search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

          let findRequest = SearchUtils.makeSearchRequest(searchOptions,
              'vUI_CustomerControl_Event_Zero_Rate',
              this.searchProviderFields,
              [])

          findRequest.order = ['EVENT_SPEND_ID'];

          PASearch.findByRequest(findRequest)
              .then((res: any[]) => {
                resolve(res)
              })
              .catch((err)=> {
                error(err)
              })
        })
      }

    }

const EventSearchProviderNoPPG: ISearchProvider =
    {
      keyFields: {id:        'WB_TEVT_ID',
        id_ui:     'EVENT_ID',
        name:      'EVENT_NAME',
      },


      searchProviderFields: vUI_CustomerControl_Event_No_PPG,

      search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

          let findRequest = SearchUtils.makeSearchRequest(searchOptions,
              'vUI_CustomerControl_No_PPG',
              this.searchProviderFields,
              [])

          findRequest.order = ['EVENT_ID'];

          PASearch.findByRequest(findRequest)
              .then((res: any[]) => {
                resolve(res)
              })
              .catch((err)=> {
                error(err)
              })
        })
      }

    }

const EventSearchProviderNoTactic: ISearchProvider =
    {
      keyFields: {id:        'WB_TEVT_ID',
        id_ui:     'EVENT_ID',
        name:      'EVENT_NAME',
      },


      searchProviderFields: vUI_CustomerControl_Event_No_Tactic,

      search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

          let findRequest = SearchUtils.makeSearchRequest(searchOptions,
              'vUI_CustomerControl_No_Tactic',
              this.searchProviderFields,
              [])

          findRequest.order = ['EVENT_ID'];

          PASearch.findByRequest(findRequest)
              .then((res: any[]) => {
                resolve(res)
              })
              .catch((err)=> {
                error(err)
              })
        })
      }

    }
*/

// Tactic Refresh

const EventSearchProviderTacticRefresh: ISearchProvider =
    {
      keyFields: {id:        'WB_TEVT_ID',
        id_ui:     'EVENT_ID',
        name:      'EVENT_NAME',
      },


      searchProviderFields: vUI_Tactics_Refresh_Fields,

      search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        let findRequest = SearchUtils.makeSearchRequest(searchOptions,
            'vUI_Tactics_Requiring_Refresh',
            this.searchProviderFields,
            [])

        findRequest.order = ['EVENT_ID'];

        async function searchTacticRefresh(findRequest: any) {
          let usrContext: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
          if (!usrContext.hasRoleId('VIEW_ALL')) {
            await SearchUtils.addUserGroupPlansFilter(findRequest, 'WB_PLAN_ID')
            SearchUtils.addUsrContextCustomerFilter(findRequest, 'WB_CUST_ID_PLANNING')
          }
          SearchUtils.addUsrContextSalesOrgFilter(findRequest, 'WB_SALESORG_ID')

          return PASearch.findByRequest(findRequest)
        }

        return searchTacticRefresh(findRequest)
      }

    }

// Tactic Refresh Status

const EventSearchProviderTacticRefreshStatus: ISearchProvider =
    {
      keyFields: {id:        'WB_TEVT_ID',
        id_ui:     'EVENT_ID',
        name:      'EVENT_NAME',
      },


      searchProviderFields: vUI_Tactics_Refresh_Status,

      search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

          let findRequest = SearchUtils.makeSearchRequest(searchOptions,
              'vUI_TPMEvent_Tactic_Refresh_Status',
              this.searchProviderFields,
              [])

          findRequest.order = ['EVENT_SPEND_ID'];

          let usrContext: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
           SearchUtils.addUsrContextSalesOrgFilter(findRequest, 'WB_SALESORG_ID')
          if (usrContext.hasRoleId('VIEW_ALL')) {
            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                  resolve(res)
                })
                .catch((err)=> {
                  error(err)
                })
            return
          }

          SearchUtils.addUsrContextCustomerFilter(findRequest, 'WB_CUST_ID_PLANNING')
          SearchUtils.addUserGroupPlansFilter(findRequest, 'WB_PLAN_ID')
              .then((ignore) => {
                return PASearch.findByRequest(findRequest)
              })
              .then((res: any[]) => {
                resolve(res)
              })
              .catch((err)=> {
                error(err)
              })
        })
      },

      // Filter with drop down in the TPM Event Search
      distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
          let findRequest = SearchUtils.makeSearchRequest({},
              'vUI_TPMEvent_Tactic_Refresh_Status',
              this.searchProviderFields,
              [fieldName])

          let usrContext: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
          SearchUtils.addUsrContextSalesOrgFilter(findRequest, 'WB_SALESORG_ID')

          if (usrContext.hasRoleId('VIEW_ALL')) {
            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                  resolve(_.map(res, (aRow) => { return aRow[fieldName] }))
                })
                .catch((err)=> {
                  error(err)
                })
            return
          }

          SearchUtils.addUsrContextCustomerFilter(findRequest, 'WB_CUST_ID_PLANNING')
          SearchUtils.addUserGroupPlansFilter(findRequest, 'WB_PLAN_ID')
              .then((ignore) => {
                return PASearch.findByRequest(findRequest)
              })
              .then((res: any[]) => {
                resolve(_.map(res, (aRow) => { return aRow[fieldName] }))
              })
              .catch((err)=> {
                error(err)
              })
        })
      }

    }
var TPMEventSearchProfileByName: ISearchProfile = {
  profileId: "default",
  profileName: "Search by Id, Name",
  renderOptions: { ui5ResourceId: "EventSearchProfileByName" },

  profileFilter: [
    {profileFilterName: 'Id',                 searchProviderFieldId: 'EVENT_ID',            renderOptions: { }},
    {profileFilterName: 'Name',               searchProviderFieldId: 'EVENT_NAME',          renderOptions: { }},
    {profileFilterName: 'Type',               searchProviderFieldId: 'TYPE_NAME',           bMultiSelect: true, renderOptions: {}},
    {profileFilterName: 'Planning Level',     searchProviderFieldId: 'PLANNING_LEVEL_NAME', bMultiSelect: true, renderOptions: {}},
    {profileFilterName: 'Period',             searchProviderFieldId: 'PLAN_PERIOD_NAME',    bMultiSelect: true, renderOptions: {}},
    {profileFilterName: 'Status',             searchProviderFieldId: 'CURRENT_STATUS_NAME', bMultiSelect: true, renderOptions: { }},
    {profileFilterName: 'Approver',           searchProviderFieldId: 'NEXT_APPROVER',       bMultiSelect: true, renderOptions: { }},
    {profileFilterName: 'Created By',         searchProviderFieldId: 'CREATED_BY',          renderOptions: { }},
    {profileFilterName: 'Planning Customer',  searchProviderFieldId: 'PLANNINGCUSTOMER',    bMultiSelect: true, renderOptions: { }}

  ],  // ISearchFields
  profileDisplayFields: [
    'EVENT_ID','EVENT_NAME','PLANNINGCUSTOMER','TYPE_NAME','CURRENT_STATUS_NAME',
    {columnTitle: "InStore Dates",   fields: ['INSTORE_START_DT','INSTORE_END_DT'], seperator: " - ",alignment: HorizAlignment.Center },
    {columnTitle: "Shipment Dates",   fields: ['SHIPMENT_START_DT','SHIPMENT_END_DT'], seperator: " - ",alignment: HorizAlignment.Center },
    'CREATED_BY','NEXT_APPROVER','PLANNING_LEVEL_NAME',{columnTitle: "Lock", lockClass: "TPMEvent", lockIdFieldName: "WB_TEVT_ID", bDisplayLockIcon: true, bDisplayLockOwner:true},
      'CREATED_DTTS', 'MODIFIED_DTTS'
  ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

  profileSearchProvider: EventSearchProviderBasic,

  profileTreeIdDefault: "byPlanType",
  profileTrees: [
    {treeId: "byPlan",
      treeName: "By Plan",
      nodeProviders: [new ColumnNodeProvider(['PLANNINGCUSTOMER','PLAN_NAME'], {defaultValues: "Empty Plan Name", levelDelimiter: "\\", ruggedTree: true})],
      renderOptions: {ui5: {leafIcon: "sap-icon://gantt-bars"}}},
    {treeId: "byPlanType",
      treeName: "By Plan, Type",
      nodeProviders: [new ColumnNodeProvider(['PLANNINGCUSTOMER','PLAN_NAME', 'TYPE_NAME'], {defaultValues: "Empty Plan Name", levelDelimiter: "\\", ruggedTree: true})],
      renderOptions: {ui5: {leafIcon: "sap-icon://gantt-bars"}}}
  ],

  // Do sorting last.. not necessary for phase 1
  profileSortIdDefault: "",    //string;
  profileSorts: [] //ISearchSort[];
}

/* AB#1709969: disabled along with EventSearchProviderZeroRate / NoPPG / NoTactic above.
const TPMEventSearchProfileByZeroRate: ISearchProfile = {
  profileId: 'EventSearchProfileByZeroRate',
  profileName: "Event - Zero Rate",
  renderOptions: { ui5ResourceId: "TPMEventSearchProfileByZeroRate"},

  profileFilter: [
    {profileFilterName: 'Event Spend',     searchProviderFieldId: 'EVENT_SPEND_ID', renderOptions: { }}
  ],  // ISearchFields
  profileDisplayFields: [
    'EVENT_SPEND_ID','EVENT_SPEND_NAME','ACTUAL_SPEND', 'PLANNED_SPEND', 'PRODUCT_GROUP_ID', 'INSTORE_START_DT','INSTORE_END_DT',{columnTitle: "Lock", lockClass: "TPMEvent", lockIdFieldName: "WB_TEVT_ID", bDisplayLockIcon: true, bDisplayLockOwner:true}    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

  profileSearchProvider: EventSearchProviderZeroRate,

  // Do sorting last.. not necessary for phase 1
  profileSortIdDefault: "",    //string;
  profileSorts: [] //ISearchSort[];
};

const TPMEventSearchProfileByNoPPG: ISearchProfile = {
  profileId: 'EventSearchProfileByNoPPG',
  profileName: "Event - No PPG",
  renderOptions: { ui5ResourceId: "TPMEventSearchProfileByNoPPG"},

  profileFilter: [
    {profileFilterName: 'Event Spend',     searchProviderFieldId: 'EVENT_SPEND_ID', renderOptions: { }}
  ],  // ISearchFields
  profileDisplayFields: [
    'EVENT_ID','EVENT_NAME','EVENT_SPEND_ID', 'EVENT_SPEND_NAME', 'RATE_AMT', 'INSTORE_START_DT','INSTORE_END_DT',{columnTitle: "Lock", lockClass: "TPMEvent", lockIdFieldName: "WB_TEVT_ID", bDisplayLockIcon: true, bDisplayLockOwner:true}    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

  profileSearchProvider:EventSearchProviderNoPPG ,



  // Do sorting last.. not necessary for phase 1
  profileSortIdDefault: "",    //string;
  profileSorts: [] //ISearchSort[];
};

const TPMEventSearchProfileByNoTactic: ISearchProfile = {
  profileId: 'EventSearchProfileByNoTactic',
  profileName: "Event - No Tactic",
  renderOptions: { ui5ResourceId: "TPMEventSearchProfileByNoTactic"},

  profileFilter: [
    {profileFilterName: 'Event Spend',     searchProviderFieldId: 'EVENT_SPEND_ID', renderOptions: { }}
  ],  // ISearchFields
  profileDisplayFields: [
    'EVENT_ID','EVENT_NAME','INSTORE_START_DT','INSTORE_END_DT','SHIPMENT_START_DT','SHIPMENT_END_DT',{columnTitle: "Lock", lockClass: "TPMEvent", lockIdFieldName: "WB_TEVT_ID", bDisplayLockIcon: true, bDisplayLockOwner:true}    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

  profileSearchProvider:EventSearchProviderNoTactic ,



  // Do sorting last.. not necessary for phase 1
  profileSortIdDefault: "",    //string;
  profileSorts: [] //ISearchSort[];
};
*/

const TPMEventSearchProfileByTacticRefresh: ISearchProfile = {
  profileId: 'EventSearchProfileByTacticRefresh',
  profileName: "Event - Tactic Refresh",
  renderOptions: { ui5ResourceId: "TPMEventSearchProfileByTacticRefresh"},

  profileFilter: [
    {profileFilterName: 'Event ID',     searchProviderFieldId: 'EVENT_ID', renderOptions: { }},
    {profileFilterName: 'Product ID',     searchProviderFieldId: 'PRODUCT_ID', renderOptions: { }}
  ],  // ISearchFields
  profileDisplayFields: [
    'PLAN_ID','PLAN_NAME','EVENT_ID','EVENT_NAME','TACTIC_ID','TACTIC_NAME','TACTIC_SHIPMENT_START_DT','TACTIC_SHIPMENT_END_DT','STATUS_NAME','ISSUE_TYPE','PRODUCT_ID','PRODUCT_NAME',{columnTitle: "Lock", lockClass: "TPMEvent", lockIdFieldName: "WB_TEVT_ID", bDisplayLockIcon: true, bDisplayLockOwner:true}   ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

  profileSearchProvider:EventSearchProviderTacticRefresh ,



  // Do sorting last.. not necessary for phase 1
  profileSortIdDefault: "",    //string;
  profileSorts: [] //ISearchSort[];
};

const TPMEventSearchProfileByTacticRefreshStatus: ISearchProfile = {
  profileId: 'EventSearchProfileByTacticRefreshStatus',
  profileName: "Tactic Status",
  renderOptions: { ui5ResourceId: "TPMEventSearchProfileByTacticRefreshStatus"},

  profileFilter: [
    {profileFilterName: 'Tactic Status',        searchProviderFieldId: 'TACTIC_STATUS',       bMultiSelect:true,  renderOptions: { }},
    {profileFilterName: 'Tactic ID',            searchProviderFieldId: 'EVENT_SPEND_ID',                          renderOptions: { }},
    {profileFilterName: 'Tactic Type',          searchProviderFieldId: 'EVENT_SPEND_TYPE',    bMultiSelect: true, renderOptions: { }},
    {profileFilterName: 'Planning Customer',    searchProviderFieldId: 'PLANNINGCUSTOMER',    bMultiSelect: true, renderOptions: { }},
    {profileFilterName: 'Planning Level',       searchProviderFieldId: 'PLANNING_LEVEL_NAME', bMultiSelect: true, renderOptions: {}},
    {profileFilterName: 'Period',               searchProviderFieldId: 'PLAN_PERIOD_NAME',    bMultiSelect: true, renderOptions: {}}
  ],  // ISearchFields
  profileDisplayFields: [
    'EVENT_ID','EVENT_NAME','EVENT_STATUS','EVENT_SPEND_ID','EVENT_SPEND_NAME','TACTIC_STATUS',{columnTitle: "Lock", lockClass: "TPMEvent", lockIdFieldName: "WB_TEVT_ID", bDisplayLockIcon: true, bDisplayLockOwner:true} ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

  profileSearchProvider:EventSearchProviderTacticRefreshStatus ,



  // Do sorting last.. not necessary for phase 1
  profileSortIdDefault: "",    //string;
  profileSorts: [] //ISearchSort[];
};


TPMEventSearch.searchProfiles = [TPMEventSearchProfileByName,TPMEventSearchProfileByTacticRefresh, TPMEventSearchProfileByTacticRefreshStatus]
PAEnvironment.registerBusinessObjectSearch("TPMEventBO", "TPMEvent", TPMEventSearch, "TPM Event Search")
export {TPMEventSearch}